import React from 'react';
import { Footer } from '@im/ui-lib/Footer';
import { useCopyrightLinks } from './useCopyrightLinks';

export function IngramFooterLite() {
  const copyRightLinks = useCopyrightLinks();

  if (!copyRightLinks) return null;

  return <Footer copyRightLinks={copyRightLinks} />;
}
